import { render, staticRenderFns } from "./TypeSolHorizon.vue?vue&type=template&id=0fefffc1&"
import script from "./TypeSolHorizon.vue?vue&type=script&lang=js&"
export * from "./TypeSolHorizon.vue?vue&type=script&lang=js&"
import style0 from "./TypeSolHorizon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports